import React, { useState } from 'react';

import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import TextInput from 'app/components/TextInput';
import TextEvents from '../TextEvents';
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip'

import { Modal, Select, Input, Radio, Icon, Switch, Button, Divider, Upload } from 'antd';

import { styles, useStyles } from './CreateWorkCycleStyles';
import { useDispatch, useSelector } from 'react-redux';

import ApiService from 'app/services/ApiService';
import { fetchWorkCycle, clearWorkCycle, fetchWorkCycleFilter, workCycleFilterClear } from 'app/actions/WorkCycleActions';

import { employeeById } from 'app/reducers';


const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;

const SelectItem = (name = [], value) => {
    let x = [...new Set(name.map(i => i[value]))];
    x = name.map(i => i[value]);
    return (
        x.map((c, i) => <Option key={i}>{c}</Option>)
    );
}

export default function CreateWorkCycle(props) {
    const { siteId } = useSelector(state => state.Auth);

    const classes = useStyles();
    const [name, setName] = useState('');
    const [description, setDesc] = useState('');
    const [subdir, setSubdir] = useState([]);
    const [open, setOpen] = useState(false);
    const [isWorkCycle, setWorkCycleStatus] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState();
    const [resWorkCycle, setResWorkCycle] = useState({});
    const [questions, setQuestions] = useState([]);
    const dispatch = useDispatch();
    const [typeQuestion, setTypeQuestion] = useState(1);
    const [isEvaluative, setEvaluative] = useState(false);

    let isReady = false;

    const employeeData = useSelector(employeeById);

    const [modal2Visible, setModal2Visible] = useState(false);

    const [state_, setState_] = useState({
        fileList: [],
        finishedOrError: false,
        uploading: false,
    })

    const { uploading, fileList } = state_;
    const actions = {
        multiple: false,
        onRemove: file => {
            setState_(state => {
                const index = state_.fileList.indexOf(file);
                const newFileList = state_.fileList.slice();
                newFileList.splice(index, 1);
                return {
                    fileList: newFileList,
                };
            });
        },
        beforeUpload: file => {
            setState_(state => ({
                fileList: [...state_.fileList, file],
            }));
            return false;
        },
        fileList,
    };

    const workCycleStatus = () => {
        setWorkCycleStatus(false)
        questions[selectedIndex].activeKey['isActive'] = false;
    }

    const showConfirm = (type) => {
        confirm({
            title: '¿Guardar Ciclo de Trabajo?',
            content: name,
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                let ids = [employeeData.idSubdirection]//subdir.map(i => i.idSubdirection);
                return ApiService.setWorkCycles({ testTitle: name, testDescription: description, TestTotalQuestion: 5, listSubdirection: ids }, 'POST')
                    .then(
                        response => {
                            if (response.idTest > -1) {
                                confirm({
                                    title: 'Ciclo de trabajo guardado correctamente.',
                                    content: '¿Desea agregar una nueva pregunta?',
                                    okText: 'Agregar pregunta',
                                    cancelText: 'Más tarde',
                                    onOk() {
                                        setWorkCycleStatus(true);
                                        setOpen(true);
                                        setResWorkCycle(response)
                                        addQuestion();
                                    },
                                    onCancel() {
                                        dispatch(clearWorkCycle());
                                        dispatch(fetchWorkCycle({ ...props.formData, Subdirection: employeeData.idSubdirection }));
                                        dispatch(workCycleFilterClear());
                                        dispatch(fetchWorkCycleFilter());
                                        props.setTab('1')
                                    },
                                });
                            } else {
                                Modal.warning({
                                    title: 'Nombre de Ciclo de trabajo',
                                    content: 'El nombre del ciclo de trabajo ingresado ya existe, intente un nuevo nombre para continuar.',
                                });
                            }
                        }, error => {
                            Modal.error({
                                title: 'Ops, error de conexión',
                                content: 'Se perdió la conexión de red, intente más tarde.',
                            });
                        }
                    )
            },
            onCancel() { },
        });
    }

    const uploadFile = async () => {
        const { fileList } = state_;
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('file', file);
        });

        setState_({
            uploading: true,
        });
        
        await ApiService.postTestWorkCyclesTemplate(formData, resWorkCycle.idTest)
            .then(response => {

                setState_({
                    uploading: false,
                });
                Modal.success({
                    title: `Preguntas guardadas correctamente.`,
                    content: response.testTitle,
                }, props.setTab('1'));
                setModal2Visible(false)
                dispatch(clearWorkCycle());
                dispatch(fetchWorkCycle({ ...props.formData, Subdirection: employeeData.idSubdirection }));
                dispatch(workCycleFilterClear());
                dispatch(fetchWorkCycleFilter());
               
            })
            .catch(error => {

                let { data } = error.response;
                Modal.error({
                    title: 'Ops, ocurrio un error.',
                    content: `${data.message}`,
                });

                setState_(state => ({
                    fileList: [],
                    finishedOrError: false,
                    uploading: false,
                }));

            })
    }

    const showSecondaryConfirm = () => {
        confirm({
            title: '¿Guardar pregunta(s)?',
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                return ApiService.setWorkCycleQuestionAnswer({ idTest: resWorkCycle.idTest, questions }, 'POST')
                    .then(
                        response => {
                            dispatch(clearWorkCycle());
                            dispatch(fetchWorkCycle({ ...props.formData, Subdirection: employeeData.idSubdirection }));
                            dispatch(workCycleFilterClear());
                            dispatch(fetchWorkCycleFilter());
                            Modal.success({
                                title: `Preguntas guardadas correctamente.`,
                                content: response.testTitle,
                            }, props.setTab('1'));
                        }, error => {
                            Modal.error({
                                title: 'Ops, error de conexión',
                                content: 'Se perdió la conexión de red, intente más tarde.',
                            });
                        }
                    )
            },
            onCancel() { },
        });
    }

    const findSubdir = (params, item) => {
        let temp = [];
        params.subdirs.forEach(v => {
            if (String(v.idSubdirection) === item.key) temp.push(v);

        });
        setSubdir(temp);
    }

    const handleClick = () => {
        setOpen(!open);
    }

    const addQuestion = () => {
        const key = questions.length <= 0 ? 0 : questions.length;
        questions.find(i => {
            return i.activeKey.isActive = false;
        });
        let question = [...new Set(questions.concat({
            questionDescription: '',
            idQuestionType: 1,
            isEvaluative: false,
            listAnswers: [
                { id: 1, type: 'radio', descriptionAnswer: 'Si', checked: false, isCorrect: false, isApplyComment: false },
                { id: 2, type: 'radio', descriptionAnswer: 'No', checked: false, isCorrect: false, isApplyComment: false }],
            activeKey: { isActive: true, key: key }
        }))];
        setTypeQuestion(1);
        setQuestions(question);
        setSelectedIndex([key]);
        setWorkCycleStatus(true);
        setOpen(true)
    }

    const selectedQuestion = (quiz, param, i) => {
        setWorkCycleStatus(true);
        setSelectedIndex(undefined)
        const isQuiz = Array.isArray(quiz);
        const typeSelected = typeof param;
        if (isQuiz && typeSelected === 'undefined') {
            questions.find(i => {
                return i.activeKey.isActive = false;
            });
            questions[quiz.length - 1].activeKey.isActive = true;
            setSelectedIndex(quiz.length - 1);
        } else if (typeSelected === 'object') {
            questions.find(i => {
                return i.activeKey.isActive = false;
            });
            questions[i].activeKey.isActive = true;
            setSelectedIndex(i)
        }
    }

    const generateQuestionList = () => {
        const descriptions = questions.find(i => {
            return i.questionDescription === '';
        })
        const answ = questions.find(i => {
            return i.listAnswers.length === 0;
        })
        if (descriptions === undefined && answ === undefined) {
            isReady = true
        }
        return questions.map((param, i) => (
            <ListItem button className={classes.nested} selected={param.activeKey.isActive} onClick={() => selectedQuestion(questions, param, i)} key={i}>
                <ListItemIcon>
                    <IconButton edge="end" aria-label="delete" className={classes.icon}>
                        <Icon type="file" style={param.questionDescription === '' ? { color: '#f50057' } : { color: 'inherit' }} />
                    </IconButton>
                </ListItemIcon>
                <Badge className={classes.margin} badgeContent={'Incompleta'} children={''} color='secondary'
                    invisible={param.questionDescription !== '' && param.listAnswers.length !== 0}
                />
                <ListItemText primary={param.questionDescription} />
                <ListItemSecondaryAction>
                    <IconButton edge="end" onClick={() => removeQuestion(i)} aria-label="delete">
                        <Icon type="delete" style={styles.addButton} />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        ))
    }

    //quiz methods
    const onChangeQuestion = (value) => {
        questions[selectedIndex].questionDescription = value.target.value;
        setQuestions([...questions])
    }

    const onChangeEvaluation = (e) => {
        setTypeQuestion(1);
        const quest = [...questions];
        quest[selectedIndex].isEvaluative = e;
        onChangeQuestionType(e);
        setEvaluative(e);
        setQuestions(quest);
    }

    const onChangeQuestionType = (e) => {
        const quest = [...questions];
        quest[selectedIndex].idQuestionType = 1;
        if (!e)
            quest[selectedIndex].listAnswers.map(i => {
                return i.isCorrect = false;
            });
        else {
            quest[selectedIndex].listAnswers.map(i => {
                return i.isCorrect = false;
            });
            quest[selectedIndex].listAnswers[0].isCorrect = true;
        }
        setQuestions(quest);
    }

    const changeText = (val, id, i) => {
        const quest = [...questions];
        quest[selectedIndex].listAnswers[i].descriptionAnswer = val;
        setQuestions(quest);
    }

    const changeComment = (param, index) => {
        const quest = [...questions]
        quest[selectedIndex].listAnswers[index].isApplyComment = !quest[selectedIndex].listAnswers[index].isApplyComment;
        setQuestions(quest)
    }

    const changeOptions = (param, index, type) => {
        const quest = [...questions];
        if (typeQuestion === 1) {
            questions[selectedIndex].listAnswers.map(i => {
                return i.isCorrect = false;
            })
            quest[selectedIndex].listAnswers[index].isCorrect = !param.isCorrect;
            setQuestions(quest)
        } else if (String(param) === 2) {
            quest[selectedIndex].listAnswers.map(i => {
                return i.isCorrect = false;
            })
            setQuestions(quest)
        }
    }

    // const removeClick = (i) => {
    //     const newOptions = [...questions];
    //     newOptions[selectedIndex].listAnswers.splice(i, 1);
    //     setQuestions(newOptions)
    // }

    const removeQuestion = (i) => {
        const newQuestions = [...questions];
        if (newQuestions.length > 1) {
            newQuestions.splice(i, 1);
            const key = newQuestions.length - 1;
            setSelectedIndex([key]);
            newQuestions[key].activeKey.isActive = true;
            setQuestions(newQuestions);
        } else {
            setOpen(false);
            setWorkCycleStatus(false);
        }
    }

    const createTextArea = () => {
        return (
            selectedIndex >= 0 ? <TextArea
                maxLength={1000}
                value={questions[selectedIndex].questionDescription}
                onChange={e => onChangeQuestion(e, selectedIndex)}
                autosize={{ minRows: 4, maxRows: 5 }}
            /> : '')
    }

    const createOptions = () => {
        const isIndex = typeof selectedIndex !== 'undefined';
        return isIndex ? <Radio.Group className={classes.radioContent}>{questions[selectedIndex].listAnswers.map((param, i) => (
            <div className={classes.flex} key={i}>
                <Radio style={styles.radioStyle} value={param.id} disabled />
                <Input
                    maxLength={1000}
                    id={String(param.id)}
                    value={param.descriptionAnswer}
                    onChange={(e) => changeText(e.target.value, questions[selectedIndex], i)}
                    placeholder='Escribe una opción'
                    className={classes.inputSelect}
                    disabled
                />
                <FormGroup >
                    <Tooltip title="Aplica comentario" placement="top">
                        <Checkbox
                            icon={<Icon type="form" />}
                            checkedIcon={<Icon type="form" className={classes.successCommentIcon} />}
                            value="checkedH"
                            checked={param.isApplyComment}
                            className={classes.checkRoot}
                            onChange={() => changeComment(param, i)}
                        />
                    </Tooltip>
                </FormGroup>
                <FormGroup >
                    <FormControlLabel
                        control={
                            <Checkbox
                                icon={<Icon type="check" />}
                                checkedIcon={<Icon type="check" className={classes.successIcon} />}
                                value="checkedH"
                                checked={param.isCorrect}
                                className={classes.checkRoot}
                                onChange={() => changeOptions(param, i)}
                            />
                        }
                        label={param.isCorrect ? 'Respuesta correcta' : ''}
                    />
                </FormGroup>
            </div>
        ))}</Radio.Group> : '';

    }

    const createCheck = (opt) => {
        return questions[selectedIndex].listAnswers.map((item, i) => (
            <div className={classes.radioContent} key={i}>
                <div className={classes.flex} >
                    <Checkbox
                        icon={<Icon type="border" fontSize="small" />}
                        checked={item.checked}
                        value={item.id}
                        color="primary"
                        className={classes.root}
                        disabled
                    />
                    <Input
                        maxLength={1000}
                        id={String(item.id)}
                        value={item.descriptionAnswer}
                        onChange={(e) => changeText(e.target.value, item.id, i)}
                        placeholder='Escribe una opción'
                        className={classes.inputSelect}
                        disabled
                    />
                    <FormGroup >
                        <Checkbox
                            icon={<Icon type="form" />}
                            checkedIcon={<Icon type="form" className={classes.successCommentIcon} />}
                            value="checkedH"
                            checked={item.isApplyComment}
                            className={classes.checkRoot}
                            disabled={isEvaluative}
                            onChange={() => changeComment(item, i)}
                        />
                    </FormGroup>
                    <FormGroup className={classes.gridSeparatorLeft}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    icon={<Icon type="check" />}
                                    checkedIcon={<Icon type="check" className={classes.successIcon} />}
                                    disabled={true}
                                    value="checkedH"
                                    checked={item.isCorrect}
                                    className={classes.checkRoot}
                                    onChange={() => changeOptions(item, i)}
                                />
                            }
                            label={item.isCorrect ? 'Respuesta correcta' : ''}
                        />
                    </FormGroup>
                </div>
            </div>
        ))
    }

    return (
        <div>
            <Modal
                title="Cargar preguntas por template"
                closable
                destroyOnClose
                visible={modal2Visible}
                onOk={() => uploadFile()}
                onCancel={() => setModal2Visible(false)}
                okButtonProps={{ disabled: fileList?.length == 0, loading: uploading }}
            >

                <Upload {...actions} disabled={siteId !== 'HUB'} accept={'.xlsx'} >
                    <Button>
                        <Icon type="upload" /> Seleccione el archivo...
                    </Button>
                </Upload>
            </Modal>
            <Grid container direction="row">
                <Grid xs={4} item>
                    <Card className={classes.leftCard}>
                        <CardContent>
                            <div>
                                <List
                                    aria-labelledby="nested-list-subheader"
                                    className={classes.principalRoot}
                                    component="nav"
                                >
                                    <ListItem button className={classes.justifyContentFlexEnd} onClick={() => addQuestion()} disabled={questions.length <= 0 || questions.length === 5}>
                                        <ListItemIcon className={classes.iconQ}>
                                            <Icon style={{ fontSize: '20px', margin: '5%' }} type='plus-circle' theme='twoTone' />
                                        </ListItemIcon>
                                        <TextEvents
                                            text='Nueva pregunta'
                                            color='gray'
                                            size='small'
                                            weight='regular'
                                        />
                                    </ListItem>
                                    <ListItem button className={classes.justifyContentFlexEnd} disabled={questions.length <= 0} onClick={() => setModal2Visible(true)}>
                                        <ListItemIcon className={classes.iconQ}>
                                            <Icon type="file-excel" style={{ fontSize: '20px', margin: '5%', color: '#288504' }} />
                                        </ListItemIcon>
                                        <TextEvents
                                            text='Cargar template'
                                            color='gray'
                                            size='small'
                                            weight='regular'
                                        />
                                    </ListItem>
                                </List>
                                <Divider />
                                <List dense={false}>
                                    <ListItem button disabled={!open} selected={!isWorkCycle} onClick={workCycleStatus}>
                                        <ListItemIcon className={classes.icon}>
                                            <Icon type="folder" />
                                        </ListItemIcon>
                                        <ListItemText primary={name} className={classes.itemText} />
                                        {isWorkCycle ? <ListItemSecondaryAction onClick={handleClick}>
                                            {open ? <Icon type="down" /> : <Icon type="up" />}
                                        </ListItemSecondaryAction> : <div />}
                                    </ListItem>
                                </List>
                                <Collapse in={open} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {questions.length > 0 ? generateQuestionList() : ''}
                                    </List>
                                </Collapse>
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
                {!isWorkCycle ? <Grid xs={8} item>
                    <Card className={classes.card}>
                        <CardContent>
                            <div className={classes.content}>
                                <Grid container direction="row">
                                    <Grid xs={6} item className={classes.gridSeparatorRight}>
                                        <TextInput
                                            value={'-'}
                                            disabled
                                            text='Folio'
                                            mode='input'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            placeholder=""
                                        >
                                        </TextInput>
                                    </Grid>
                                    <Grid xs={6} item className={classes.gridSeparatorLeft}>
                                        <TextInput
                                            disabled
                                            text='Estatus'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            mode="multiple"
                                            placeholder="Edición"
                                        >
                                        </TextInput>
                                    </Grid>
                                    <Grid xs={12} item >
                                        <Grid item xs={12}>
                                            <TextEvents
                                                text='Subdirección origen'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <SubdirectionsContainer>
                                                {(params) => {
                                                    return (
                                                        <Select
                                                            disabled={true}//{Object.keys(resWorkCycle).length > 0}
                                                            //labelInValue
                                                            placeholder={'Selecciona subdirección'}
                                                            //value={{ key: subdir.length > 0 ? String(subdir[0].idSubdirection) : '' }}
                                                            //value={params.subdirs.length > 0 ? String(params.subdirs.filter(item => item.idSubdirection === employeeData.idSubdirection)[0].idSubdirection) : ''}
                                                            value={String(employeeData.idSubdirection)}
                                                            style={{ width: "100%" }}
                                                            onChange={(item) => {
                                                                findSubdir(params, item);
                                                            }}
                                                        >
                                                            {
                                                                params.subdirs.map((item) => {
                                                                    return (
                                                                        <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                            {item.subdirectionName}
                                                                        </Select.Option>
                                                                    )
                                                                })
                                                            }
                                                        </Select>
                                                    )
                                                }}
                                            </SubdirectionsContainer>
                                        </Grid>
                                        <TextInput
                                            disabled={Object.keys(resWorkCycle).length > 0}
                                            value={name}
                                            setValue={setName}
                                            text='Nombre'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            mode='input'
                                            placeholder='Nombre'
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                <TextEvents
                                    text='Descripción'
                                    color='darker'
                                    size='label'
                                    weight='medium'
                                />
                                <TextArea
                                    disabled={Object.keys(resWorkCycle).length > 0}
                                    maxLength={1000}
                                    value={description}
                                    onChange={e => setDesc(e.target.value)}
                                    autosize={{ minRows: 5, maxRows: 6 }}
                                    placeholder='Descripción..'
                                />
                            </div>
                            <div className={classes.buttonsContainer}>
                                <Button
                                    variant='contained'
                                    type="primary"
                                    onClick={showConfirm}
                                    disabled={Object.keys(resWorkCycle).length > 0 /*|| subdir.length === 0*/ || name === '' || description === ''}
                                > Guardar</Button>
                                <Button type="danger" ghost
                                    variant='contained'
                                    className={classes.button}
                                    onClick={() => props.setTab('1')}
                                >Cancelar</Button>
                            </div>
                        </CardContent>
                    </Card>
                </Grid> :
                    <Grid xs={8} item>
                        <Card className={classes.card}>
                            <CardContent>
                                <div className={classes.content}>
                                    <Grid container direction="row">
                                        <Grid xs={12} item className={classes.gridSeparatorTop}>
                                            {typeof questions !== 'undefined' ?

                                                <div>
                                                    {/* AQUI VA EL QUIZ */}
                                                    <Grid container direction="row">
                                                        <Grid xs={12} item className={classes.gridSeparatorRight}>
                                                            <TextEvents
                                                                text='Pregunta'
                                                                color='darker'
                                                                size='label'
                                                                weight='medium'
                                                            />
                                                            {createTextArea()}
                                                        </Grid>
                                                        {typeQuestion === 'text' ? '' :
                                                            <Grid xs={12} item className={classes.gridSeparatorTop}>
                                                                <TextEvents
                                                                    text={'¿Aplica para evaluación?'}
                                                                    color='darker'
                                                                    size='label'
                                                                    weight='medium'
                                                                    styleDisplay={'initial'}
                                                                    styleMargin={'1%'}
                                                                />
                                                                <Switch checkedChildren='Si' unCheckedChildren='No' defaultChecked={questions[selectedIndex].isEvaluative} checked={questions[selectedIndex].isEvaluative} onChange={(e) => onChangeEvaluation(e)} />
                                                            </Grid>}
                                                        <Grid xs={12} item className={classes.gridSeparatorTop}>
                                                            <Divider>Opciones</Divider>
                                                            {/*<Radio.Group value={typeQuestion} onChange={(e) => setTypeQuestion(e.target.value)} style={{ width: '100%', marginBottom: 16 }}>
                                                                <Radio.Button value={1} onClick={(e) => onChangeQuestionType(e.target.value)}>Simple</Radio.Button>
                                                                <Radio.Button value={2} onClick={(e) => onChangeQuestionType(e.target.value)} disabled={!questions[selectedIndex].isEvaluative}>Múltiple</Radio.Button>
                                                            </Radio.Group>*/}
                                                        </Grid>
                                                        {questions[selectedIndex].isEvaluative ?
                                                            <Grid xs={12} item >
                                                                {createOptions()}
                                                            </Grid> :
                                                            <Grid xs={12} item >
                                                                {createCheck(questions)}
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                    {/* AQUI CIERRA EL QUIZ */}
                                                </div> : ''}
                                        </Grid>
                                    </Grid>
                                </div>
                            </CardContent>
                        </Card>
                        <div className={classes.buttonsContainer}>
                            <Button
                                variant='contained'
                                type="primary"
                                onClick={showSecondaryConfirm}
                                disabled={questions.length <= 0 || !isReady}
                            > Guardar</Button>
                            <Button type="danger" ghost
                                variant='contained'
                                className={classes.button}
                                onClick={() => props.setTab('1')}
                            >Cancelar</Button>
                        </div>
                    </Grid>}
            </Grid>

        </div>
    );
}